export default __webpack_public_path__ + "c4101fd4fc4edf7c27c6e866e7ebbbf0.woff";